import { defineMessages } from 'react-intl'

const scope = `procurify.expense.presenter.ApproveExpensePresenter`

export default defineMessages({
  approveSuccess: {
    id: `${scope}.approveSuccess`,
    defaultMessage: 'Expense report #{expenseId} approved successfully',
  },
  approveError: {
    id: `${scope}.approveError`,
    defaultMessage: 'Failed to approve expense report',
  },
})
